module.exports = __webpack_public_path__ + "img/ico_talk_bubble.9bb45c50.svg";